import React, { useContext, useEffect, useMemo, useState } from "react";
import { Badge, IconButton, Popover, Tooltip } from "@mui/material";

import AlertIcon from "../IconComponents/AlertIcon";
import AlertNotifsList from "./AlertNotifsList";
import { ticketService } from "../../service/ticketService";
import { NavContext } from "../../App";

import styles from "./SpecialNotificationList.module.css";

export default function SpecialNotificationList() {
  const context = useContext(NavContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const open = Boolean(anchorEl);
  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.lu).length,
    [notifications]
  );

  useEffect(() => {
    ticketService
      .getSpecialNotifications()
      .then((res) => setNotifications(res?.data?.result?.notifications ?? []))
      .catch((error) =>
        console.error("Error fetching special notifications:", error)
      );
  }, [open, context.newNotification]);

  return (
    <>
      <Tooltip title="Alertes" arrow>
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          className={styles.triggerBtn}
          aria-label={`Alertes${unreadCount ? ` (${unreadCount} non lues)` : ""}`}
        >
          <Badge
            badgeContent={unreadCount}
            color="error"
            overlap="circular"
            max={99}
          >
            <AlertIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { className: styles.popoverPaper } }}
      >
        <div className={styles.popoverHeader}>
          <span className={styles.popoverTitle}>Notifications</span>
          {unreadCount > 0 && (
            <span className={styles.unreadPill}>
              {unreadCount} non lue{unreadCount > 1 ? "s" : ""}
            </span>
          )}
        </div>

        <div className={styles.popoverBody}>
          <AlertNotifsList notifications={notifications} />
        </div>
      </Popover>
    </>
  );
}